module.exports = __webpack_public_path__ + "static/media/progress-report.33c4bcac.svg";